import { gql } from '@apollo/client';
const Fragments = {
  genericFilterParam: gql`
    fragment genericFilterParamItem on GenericFilterParam {
      paramId
      paramCode
      paramName
      paramTypeId
      paramTypeName
      paramIsList
      checkListEditMode
      isAllowedIncFetch
      genericFilterParamValues {
        id
        paramId
        name
      }
    }
  `
};

export default Fragments;
